import { useMemo } from 'react';

import { SelectField, SelectFieldProps } from '@/components/molecules/SelectField';
import { useGetMasterList } from '@/hooks/useGetMasterList';
import { findMasterDataGroup } from '@/utils';

type Props<IForm extends object> = SelectFieldProps<
  IForm,
  {
    id: string;
    value: string;
  }
>;

export const SelectDegree = <IForm extends object>(props: Props<IForm>) => {
  const { data, isLoading, isFetching } = useGetMasterList();
  const degreeList = useMemo(() => findMasterDataGroup(data, 'BANG-CAP', '4'), [data]);

  const selectProps = {
    autoFocus: props.autoFocus,
    className: props.className,
    classNameInputHint: props.classNameInputHint,
    clearable: props.clearable,
    control: props.control,
    disabled: props.disabled,
    emptyOptionText: props.emptyOptionText,
    emptySearchResultText: props.emptySearchResultText,
    errorClass: props.errorClass,
    getOptionLabel: (option: { id: string; value: string }) => option.value,
    groupClass: props.groupClass,
    hint: props.hint,
    hintClass: props.hintClass,
    id: props.id,
    isLoading: props.isLoading || isLoading || isFetching,
    label: props.label,
    labelClass: props.labelClass,
    name: props.name,
    options: degreeList?.data || [],
    placeholder: props.placeholder,
    required: props.required,
    rtl: props.rtl,
    searchable: props.searchable,
    solid: props.solid,
  };

  if (props.multiple && !props.getOptionValue) {
    return <SelectField {...selectProps} onChange={props.onChange} value={props.value} multiple />;
  }

  if (!props.multiple && !props.getOptionValue) {
    return <SelectField {...selectProps} onChange={props.onChange} value={props.value} />;
  }

  if (!props.multiple && props.getOptionValue) {
    return (
      <SelectField
        {...selectProps}
        getOptionValue={props.getOptionValue}
        onChange={props.onChange}
        value={props.value}
      />
    );
  }

  return (
    <SelectField
      {...selectProps}
      getOptionValue={props.getOptionValue}
      onChange={props.onChange}
      value={props.value}
      multiple
    />
  );
};
